import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Task } from '../../types';

interface CancelTaskModalProps {
  task: Task;
  onConfirm: () => void;
  onCancel: () => void;
}

const CancelTaskModal: React.FC<CancelTaskModalProps> = ({ task, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <div className="flex items-center space-x-2 text-red-600 mb-4">
          <AlertTriangle className="h-6 w-6" />
          <h2 className="text-xl font-bold">Annuler la tâche</h2>
        </div>

        <p className="mb-4">
          Êtes-vous sûr de vouloir annuler cette tâche ? Cette action est irréversible.
        </p>

        <div className="flex justify-end space-x-2">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Non, garder
          </button>

          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Oui, annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelTaskModal;